import React from 'react';
import clsx from 'clsx';
import EnterpriseLayout from '../components/layout/EnterpriseLayout';
import TransactionTabsWithCSV from '../components/TransactionTabsWithCSV';
import styles from '../styles/views/Transactions.module.scss';

function Transactions() {
  return (
    <EnterpriseLayout 
      pageTitle="Transactions"
      pageDescription="Monitor all your credit transactions, repayments, and fee payments in real-time. Track your financial activity across all supported networks and stable coins."
      pageBodyClassName={clsx(styles.cTransactions, "c-transactions")}
    >
      <div className={styles.transactionsContainer}>
        {/* Stats Overview */}
        {/* <div className={styles.statsSection}>
          <div className={styles.statsGrid}>
            <div className={styles.statCard}>
              <div className={styles.statIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.statContent}>
                <div className={styles.statValue}>Credit</div>
                <div className={styles.statLabel}>Transactions</div>
              </div>
            </div>
            
            <div className={styles.statCard}>
              <div className={styles.statIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className={styles.statContent}>
                <div className={styles.statValue}>Repayments</div>
                <div className={styles.statLabel}>History</div>
              </div>
            </div>
            
            <div className={styles.statCard}>
              <div className={styles.statIcon}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                  <line x1="1" y1="10" x2="23" y2="10" stroke="currentColor" strokeWidth="2"/>
                </svg>
              </div>
              <div className={styles.statContent}>
                <div className={styles.statValue}>Fee Payments</div>
                <div className={styles.statLabel}>Record</div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Main Content */}
        <div className={styles.mainContent}>
          <div className={styles.transactionSection}>
            <TransactionTabsWithCSV />
          </div>
        </div>
      </div>
    </EnterpriseLayout>
  );
}

export default Transactions;
